import TagCreationForm from "./TagCreationForm";

export default TagCreationForm;
